module.exports = __webpack_public_path__ + "img/20dbf30bd27135427d04ecb8d72fe2ed.png";